<template>
  <div class="content flex-box vertical no-padding">
    <div class="content-title">订餐设置</div>
    <div class="flex-grow">
      <div class="food-set" v-if="edit">
        <form-area
          ref="setForm"
          layout="horizontal"
          hide-btn
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 20 }"
          :items="items"
          :entity="form"
          :extra-rules="extraRules"
        >
          <template v-slot:front="{form}">
            <a-form-model-item label="订餐日期" prop="meal_date">
              <item-list add-title="添加日期" v-model="form.meal_date">
                <template v-slot:input="{ action: confirmCallback }">
                  <a-date-picker open value-format="YYYY-MM-DD" placeholder="选择日期" @change="confirmCallback" />
                </template>
              </item-list>
            </a-form-model-item>
          </template>
        </form-area>
      </div>
      <div class="food-set" v-else>
        <div class="detail-info-item" v-for="item in infoList" :key="item.key">
          <div class="detail-info-label">{{ item.label }}</div>
          <div class="detail-info-value">
            <a-space align="center" v-if="Array.isArray(item.value)">
              <a-tag v-for="(t, i) in item.value" :key="i">{{t}}</a-tag>
            </a-space>
            <span v-else>{{ item.value || '未设置'}}</span>
          </div>
        </div>
      </div>
    </div>
    <template v-if="editable">
      <a-space class="footer" v-if="edit">
        <a-button @click="cancel">取消</a-button>
        <a-button type="primary" :loading="loading" @click="save">保存</a-button>
      </a-space>
      <a-space class="footer" v-else>
        <a-button type="primary" @click="editSet">编辑</a-button>
      </a-space>
    </template>
  </div>
</template>

<script lang="tsx">
    import { getDate } from "../../../common/js/tool";
    import mixins from "../mixins";

    export default {
        name: "FoodSet",
        mixins: [mixins],
        inject: ["parent"],
        data() {
            return {
                loading: false,
                edit: false,
                form: {},
                extraRules: {
                    meal_date: [
                        { required: true, message: "请设置订餐日期", trigger: "change" },
                    ]
                },
                items: [
                    {
                        key: "meal_start_time",
                        label: "服务开始时间",
                        component: "a-date-picker",
                        props: {
                            showTime: true,
                            format: "YYYY-MM-DD HH:mm",
                            valueFormat: "YYYY-MM-DD HH:mm",
                            placeholder: "开始时间",
                        },
                        rules: [
                            { required: true, message: "请设置服务开始时间", trigger: "change" },
                        ],
                    },
                    {
                        key: "meal_end_time",
                        label: "服务结束时间",
                        component: "a-date-picker",
                        props: {
                            showTime: true,
                            format: "YYYY-MM-DD HH:mm",
                            valueFormat: "YYYY-MM-DD HH:mm",
                            placeholder: "结束时间",
                        },
                        rules: [
                            { required: true, message: "请设置服务结束时间", trigger: "change" },
                        ],
                    }
                ],
                moduleKey: 'food-set',
            }
        },
        computed: {
            infoList() {
                const activity = this.activity;
                const res = [
                    { label: '订餐日期', value: '', key: 'date' },
                    { label: '服务开始时间', value: '', key: 'start' },
                    { label: '服务结束时间', value: '', key: 'end' },
                ]
                if (activity) {
                    if (activity.meal_date) {
                        res[0].value = activity.meal_date.split(",")
                    }
                    if (activity.meal_start_time) {
                        res[1].value = getDate(activity.meal_start_time).pattern("yyyy-MM-dd HH:mm");
                    }
                    if (activity.meal_end_time) {
                        res[2].value = getDate(activity.meal_end_time).pattern("yyyy-MM-dd HH:mm");
                    }
                }
                return res;
            },
            activity() {
                return this.$store.getters.activity;
            },
        },
        methods: {
            cancel() {
                this.edit = false;
            },
            save() {
                this.loading = true;
                this.$refs.setForm.handleConfirm().then(form => {
                    const data = { ...form };
                    const activity = this.activity;
                    let url = `/activity/activity/${activity.id}`, method = "PATCH";
                    this.$axios({
                        url,
                        method,
                        data,
                    })
                        .then(() => {
                            this.parent && this.parent.getActivity();
                            this.edit = false;
                            this.$message.success("已保存");
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }).finally(() => {
                    this.loading = false;
                })
            },
            editSet() {
                const form = {};
                if (this.activity) {
                    form.meal_date = this.activity.meal_date;
                    form.meal_start_time = this.activity.meal_start_time;
                    form.meal_end_time = this.activity.meal_end_time;
                }
                this.form = form;
                this.edit = true;
            },
        }
    }
</script>

<style scoped lang="less">
.food-set {
  margin: 0 auto;
  padding: @padding-md;
  max-width: 960px;
}
</style>
